export default function getResource(label) {
    const resources = {
        title: 'Compte désactivé',
        confirmText: 'OK'
    };

    return resources[label];
}
